<template>
  <el-drawer
    class="ruibao-drawer"
    direction="rtl"
    title="查看"
    :visible="visible"
    :before-close="handleClose"
    :size="600"
  >
    <div class="ruibao-detail">
      <div class="ruibao-detail__section">
        <div class="title">采集图片 {{ data.createdAt | formatDate }}</div>
        <div class="content" style="padding:0">
          <el-image
            :src="data.predImg"
            @click="showImage(data)"
            style="cursor:pointer"
          />
        </div>
      </div>

      <div class="ruibao-detail__section">
        <div class="title">
          分析数据
        </div>
        <div class="content">
          <div class="insect-row">
            <div class="insect-label">- 合计: ({{ summary.count }})</div>

            <div class="insects-content">
              <div class="insect">
                <span class="label">长翅成虫</span>
                <span class="data">{{ summary.long }}</span>
              </div>
              <div class="insect">
                <span class="label">短翅成虫</span>
                <span class="data">{{ summary.short }}</span>
              </div>
              <div class="insect">
                <span class="label">高龄若虫</span>
                <span class="data">{{ summary.elder }}</span>
              </div>
              <div class="insect">
                <span class="label">低龄若虫</span>
                <span class="data">{{ summary.young }}</span>
              </div>
            </div>
          </div>

          <div
            class="insect-row"
            v-for="insect in data.insects"
            :key="insect.id"
          >
            <div class="insect-label">
              - {{ insect.name }}: ({{ insect.count }})
            </div>
            <div class="insects-content">
              <div class="insect">
                <span class="label">长翅成虫</span>
                <span class="data">{{ insect.long }}</span>
              </div>
              <div class="insect">
                <span class="label">短翅成虫</span>
                <span class="data">{{ insect.short }}</span>
              </div>
              <div class="insect">
                <span class="label">高龄若虫</span>
                <span class="data">{{ insect.elder }}</span>
              </div>
              <div class="insect">
                <span class="label">低龄若虫</span>
                <span class="data">{{ insect.young }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ruibao-detail__section">
        <div class="title">
          基础信息
        </div>
        <div class="content">
          <div class="insect-row">
            <span class="label">采集时间：</span>
            <span class="data">{{ data.createdAt | formatDate }}</span>
          </div>

          <div class="insect-row">
            <span class="label">采集用户：</span>
            <span class="data">{{ data.nikeName }}</span>
          </div>

          <div class="insect-row">
            <span class="label">采集地点：</span>
            <span class="data">{{ data.address }}</span>
          </div>

          <div class="insect-row">
            <span class="label">田块标注：</span>
            <span class="data">{{ data.field || '未标注' }}</span>
          </div>

          <div class="insect-row">
            <span class="label">采集设备：</span>
            <span class="data">{{ data.code }}</span>
          </div>
          <!-- <div class="insect-row">
            <span class="label">备注：</span>
            <span class="data">{{ data.remark }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: { visible: Boolean, opening: Boolean, data: Object },
  computed: {
    summary() {
      let insects = this.data.insects || []
      let obj = insects.reduce(
        (prev, ins) => {
          return {
            long: prev.long + ins.long,
            short: prev.short + ins.short,
            elder: prev.elder + ins.elder,
            young: prev.young + ins.young
          }
        },
        { long: 0, short: 0, elder: 0, young: 0 }
      )

      return { ...this.data, ...obj }
    }
  },
  methods: {
    handleClose(done) {
      if (!this.opening) {
        this.$emit('update:visible', false)
        done()
      }
    },
    showImage(row) {
      this.$emit('show-image', row)
    }
  }
}
</script>

<style lang="scss">
.ruibao-drawer {
  .el-drawer__header {
    background-color: #f1f1f1;
    margin-bottom: 0;
    padding-bottom: 20px;
  }
  .el-drawer {
    height: 100%;
    display: flex;
  }
  .el-drawer__body {
    flex: 1;
    overflow: auto;
  }
}
.ruibao-detail {
  padding: 20px;
}
.ruibao-detail__section {
  padding-bottom: 20px;
  .title {
    font-size: 16px;
    border-left: 8px solid #409eff;
    padding-left: 10px;
    margin-bottom: 20px;
  }
  .content {
    width: 100%;
    background-color: #f8f8f8;
    font-size: 14px;
    padding: 10px;
    .label {
      color: #303133;
    }
  }

  .data {
    color: #909399;
    padding-left: 8px;
  }
  .insect-row {
    box-sizing: border-box;
    &:not(:last-child) {
      margin-bottom: 12px;
    }
    .insect {
      display: inline-block;
      width: 50%;
      padding: 4px;
      box-sizing: border-box;
    }
    .insect-label {
      font-size: 1rem;
      margin-bottom: 6px;
    }
    .insects-content {
      padding-left: 1.5rem;
    }
  }
}
</style>
